import { Link } from 'react-router-dom';
import { articlesByCategory } from '@/mocks/articles';

export default function EventsSection() {
  const events = articlesByCategory('events').slice(0, 3);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50" aria-labelledby="events-title">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <p className="text-xs md:text-sm text-primary-500 font-medium tracking-widest mb-2">UPCOMING EVENTS</p>
            <h2 id="events-title" className="font-heading text-2xl md:text-3xl text-foreground-950">活动信息</h2>
          </div>
          <Link
            to="/category/events"
            className="flex items-center gap-1.5 text-sm text-secondary-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {events.map((event, idx) => (
            <Link
              key={event.slug}
              to={`/article/${event.slug}`}
              className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer"
            >
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={event.image}
                  alt={event.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-3">
                  <span className={`inline-block w-2 h-2 rounded-full ${idx === 0 ? 'bg-accent-500' : 'bg-secondary-400'}`}></span>
                  <span className="text-xs text-foreground-400">{event.date}</span>
                </div>
                <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2">
                  {event.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {event.summary}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}